import React from 'react';
import PropTypes from 'prop-types';
import overrideStyle from 'lib/overrideStyle';

import QuickActionItem from './QuickActionItem';

export const StyledQuickActions = overrideStyle('div')`
  cursor: pointer;
  flex: 1;
  overflow: auto;
  padding: 24px 24px 0;
`;

export default class QuickActions extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <StyledQuickActions data-aid="selfService-quickActions">
        {this.props.quickActions.map((answer, index) => (
          <QuickActionItem answer={answer} key={index} />
        ))}
      </StyledQuickActions>
    );
  }
}

QuickActions.propTypes = {
  quickActions: PropTypes.array,
};
